import { render, staticRenderFns } from "./DexPNModal.vue?vue&type=template&id=6e1b1664&scoped=true"
import script from "./DexPNModal.vue?vue&type=script&lang=ts"
export * from "./DexPNModal.vue?vue&type=script&lang=ts"
import style0 from "./DexPNModal.vue?vue&type=style&index=0&id=6e1b1664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1b1664",
  null
  
)

export default component.exports